import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FileField, FileInput } from 'react-admin'
import get from 'lodash/get'
import SparkMD5 from 'spark-md5'

import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';

import httpClient from '../../utils/httpClient'

const MAX_SIZE = 1024 * 1024 * 1024 * 2
const CHUNK_SIZE = 1024 * 512
const UPLOAD_URL = `${process.env.API_URL}/api/v1/upload`

const noop = () => {}
const getChunk = (file, start, end) => {
    let slice = file.mozSlice || file.webkitSlice || file.slice || noop;
    return slice.bind(file)(start, end);
}

const readUploadedFile = (inputFile) => {
  const temporaryFileReader = new FileReader();

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort();
      reject(new DOMException("Problem parsing input file."));
    };
    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result);
    };
    temporaryFileReader.readAsArrayBuffer(inputFile);
  });
};

class DocumentoUploadDialog extends Component {
    state = {
        open: false,
        uploading: false,
        completed: 0,
        buffer: 0,
        error: null
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleUpload = async () => {
        this.setState({
            uploading: true,
            completed: 0,
            buffer: 0
        });

        try {
            const document = await this.documentUpload(
                this.props.file.rawFile,
                this.props.file.title
            )
            this.setState({ uploading: false })
            this.props.changeSelectValue(document.id, document.file_name)
            this.handleClose()
        } catch (e) {
            console.log(e)
            this.setState({
                uploading: false,
                completed: 0,
                buffer: 0,
                error: e
            })
        }

    }

    documentUpload = async (file, filename) => {
        const totalSize = file.size
        try {
            const fileContents = await readUploadedFile(file)
            const checksum = SparkMD5.ArrayBuffer.hash(fileContents)
            // If file is small enough, send whole file
            if (totalSize <= CHUNK_SIZE) {
                // Send POST request with file, filename, md5, type & decreto
                let formData = new FormData()
                formData.append("file", file)
                formData.append("md5", checksum)
                formData.append("type", this.props.documentType)
                formData.append("decreto", this.props.decreto)
                formData.append("filename", filename)

                try {
                    this.setState({ buffer: 100 })
                    const onlyResponse = await httpClient(`${UPLOAD_URL}/`, {
                        method: "POST",
                        body: formData,
                        headers: new Headers({ Accept: 'application/json' })
                    })
                    this.setState({ completed: 100 })
                    return onlyResponse.json
                } catch (e) {
                    this.setState({
                        uploading: false,
                        completed: 0,
                        buffer: 0,
                        error: "Error while uploading whole file"
                    })
                    return Promise.reject("Error while uploading whole file")
                }
            } else {
                // First Chunk
                let start = 0
                let end = start + CHUNK_SIZE
                const totalChunks = Math.ceil(totalSize/CHUNK_SIZE)
                const step = 100/totalChunks

                let formData = new FormData()
                formData.append("file", getChunk(file, start, end))
                formData.append("type", this.props.documentType)
                formData.append("decreto", this.props.decreto)
                formData.append("filename", filename)

                let headers = new Headers({ Accept: 'application/json' })
                headers.set('Content-Range', `bytes ${start}-${end-1}/${totalSize}`)
                try {
                    this.setState({ buffer: this.state.buffer + step })
                    let chunkResponse = await httpClient(`${UPLOAD_URL}/`, {
                        method: 'PUT',
                        body: formData,
                        headers
                    })
                    this.setState({ completed: this.state.buffer })
                    const documentUrl = `${UPLOAD_URL}/${chunkResponse.json.id}/`

                    // Remaining chunks
                    start = chunkResponse.json.offset
                    while (end < totalSize){
                        end = start + CHUNK_SIZE
                        if (end > totalSize) {
                            end = totalSize
                        }

                        formData = new FormData()
                        formData.append("file", getChunk(file, start, end))

                        headers = new Headers({ Accept: 'application/json' })
                        headers.set('Content-Range', `bytes ${start}-${end-1}/${totalSize}`)
                        this.setState({ buffer: this.state.buffer + step })
                        chunkResponse = await httpClient(documentUrl, {
                            method: 'PUT',
                            body: formData,
                            headers
                        })
                        this.setState({ completed: this.state.buffer })
                        start = chunkResponse.json.offset
                    }

                    formData = new FormData()
                    formData.append("md5", checksum)
                    formData.append("type", this.props.documentType)
                    formData.append("decreto", this.props.decreto)
                    formData.append("filename", filename)
                    const finalResponse = await httpClient(documentUrl, {
                        method: 'POST',
                        body: formData,
                        headers: new Headers({ Accept: 'application/json' })
                    })
                    return finalResponse.json
                } catch (e) {
                    console.log(e)
                    return Promise.reject("Upload Failed")
                }
            }
        } catch (e) {
            this.setState({
                uploading: false,
                completed: 0,
                buffer: 0,
                error: "Error while calculating MD5 checksum"
            })
            return Promise.reject("Error while calculating MD5 checksum")
        }
    }

    render() {
        const { open, uploading, completed, buffer } = this.state

        return (
            <div>
                <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
                    Subir Documento
                    <CloudUploadIcon style={{ marginLeft: '10px' }}/>
                </Button>
                <Dialog
                    open={open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth={'sm'}
                >
                    <DialogTitle id="form-dialog-title">Subir Documento</DialogTitle>
                    <DialogContent>
                        <FileInput
                            source="document_upload"
                            label="Documento"
                            placeholder={<p>Arrastra un archivo, o haz clic aquí para buscarlo, las extensiones permitidas son: <strong>{this.props.acceptedExt.join(', ')}</strong></p>}
                            accept={this.props.acceptedExt.join(', ') || "*/*"}
                            maxSize={MAX_SIZE}
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                        {!!this.state.error && <p>Error al subir el archivo</p>}
                        {uploading && <LinearProgress variant="buffer" value={completed} valueBuffer={buffer} />}
                        {uploading && `${completed.toFixed(2)}%`}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleUpload} color="primary" disabled={uploading}>
                            {uploading ? "Subiendo Archivo..." : "Subir Documento"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const file = get(state, 'form.record-form.values.datasheet.document_upload', null)
    const decreto = get(state, 'form.record-form.values.decreto_id', null)
    return { file, decreto }
}

export default connect(mapStateToProps)(DocumentoUploadDialog)
